import {
  DEPENDENCY_HEALTH_TYPES,
  ITEM_HEALTH_RISK_TYPES,
  MISSING_DATA_HEALTH_TYPES,
} from '@/lib/api/types/dashboard/health';
import type { Confidence } from '../../shared/impact/confidence';

// Synthetic insight IDs that don't map to a single dashboard enum value.
// `ESTIMATION_DRIFT` merges the two `DELTA_DIFF_LARGER_THAN_*_PERCENT` health-risk
// types — they describe the same underlying drift at different thresholds and
// reading them as separate insights is noisy.
export const SYNTHETIC_INSIGHT_IDS = {
  ESTIMATION_DRIFT: 'ESTIMATION_DRIFT',
} as const;

export const HEALTH_SIGNAL_INSIGHT_IDS = [
  ITEM_HEALTH_RISK_TYPES.PLANNED_START_DATE_PASSED,
  ITEM_HEALTH_RISK_TYPES.PLANNED_FINISH_DATE_PASSED,
  ITEM_HEALTH_RISK_TYPES.UNPLANNED_WORK,
  SYNTHETIC_INSIGHT_IDS.ESTIMATION_DRIFT,
  MISSING_DATA_HEALTH_TYPES.MISSING_ESTIMATES,
  MISSING_DATA_HEALTH_TYPES.NO_TEAM_ASSIGNED,
  MISSING_DATA_HEALTH_TYPES.DISCONNECTED_FROM_STRATEGY,
  DEPENDENCY_HEALTH_TYPES.BLOCKED_BY_ITEMS,
] as const;

export type HealthSignalInsightId = (typeof HEALTH_SIGNAL_INSIGHT_IDS)[number];

export const isHealthSignalInsightId = (value: string): value is HealthSignalInsightId =>
  (HEALTH_SIGNAL_INSIGHT_IDS as readonly string[]).includes(value);

export interface Insight {
  id: HealthSignalInsightId;
  title: string;
  description: string;
  showMyWork: string;
  signalText: string;
  confidence: Confidence;
  affectedCount: number;
  affectedPercentage: number;
}

// Category grouping used by the toolbar filter chips and the per-card meta-row
// tag. Each insight belongs to exactly one category; the mapping lives in
// `utils/insightTypes.ts`.
export const HEALTH_INSIGHT_TYPES = [
  'dependencies',
  'progress',
  'estimation',
  'data-hygiene',
  'misalignment',
] as const;

export type HealthInsightType = (typeof HEALTH_INSIGHT_TYPES)[number];

export const isHealthInsightType = (value: string): value is HealthInsightType =>
  (HEALTH_INSIGHT_TYPES as readonly string[]).includes(value);
